// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './components/ThemeContext';
import { LanguageProvider } from './components/LanguageContext';
import { ModalProvider } from './components/ModalContext';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

import Sidebar from './components/Sidebar';
import Hero from './components/Hero';
import About from './components/About';
import WhyHedera from './components/WhyHedera';
import Ecosystem from './components/Ecosystem';
import ToolsAccordion from './components/ToolsAccordion';
import StatsBlock from './components/StatsBlock';
import BlockchainFeatures from './components/BlockchainFeatures';
import FAQs from './components/FAQs';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ChemicalFormulas from './components/ChemicalFormulas';
import AnnouncementBanner from './components/AnnouncementBanner';
import WhataNews from './components/WhataNews';
import WhataNewsEdit from './components/WhataNewsEdit';
import WhataNewsLogin from './components/WhataNewsLogin';
import Links from './components/Links';
import SplitAudience from './components/SplitAudience';
import WhataTeam from './components/WhataTeam';
import Maintenance from './components/Maintenance';
import AssemblyNoticeModal from './components/AssemblyNoticeModal';
import { MAINTENANCE_MODE, SHOW_ANNOUNCEMENT_BANNER, SHOW_ASSEMBLY_NOTICE } from './config';
import './styles/index.css';

const LandingPage = () => (
  <>
    {SHOW_ANNOUNCEMENT_BANNER && <AnnouncementBanner />}
    <div className="App app-with-sidebar">
      <Sidebar />
      <main className="main-content">
        <Hero />
        <ToolsAccordion />
        <StatsBlock />
        <SplitAudience />
        <Ecosystem />
        <BlockchainFeatures />
        <WhyHedera />
        <About />
        <WhataTeam />
        <FAQs />
        <Footer />
      </main>
      <ScrollToTop />
      <ChemicalFormulas />
    </div>
    {SHOW_ASSEMBLY_NOTICE && <AssemblyNoticeModal />}
  </>
);

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <ModalProvider>
          <AuthProvider>
            <Router>
              <Routes>
                {/* Landing — en mantenimiento se sirve la pantalla de mantenimiento */}
                <Route path="/" element={MAINTENANCE_MODE ? <Maintenance /> : <LandingPage />} />

                {/* Links Page */}
                <Route path="/links" element={<Links />} />

                {/* Noticias públicas */}
                <Route path="/whatanews" element={<WhataNews />} />
                <Route path="/whatanews/:slug" element={<WhataNews />} />

                {/* Login del editor */}
                <Route path="/news-login" element={<WhataNewsLogin />} />

                {/* Alias antiguo: /blog-login → /news-login */}
                <Route path="/blog-login" element={<Navigate to="/news-login" replace />} />

                {/* Editor protegido */}
                <Route
                  path="/whatanews-edit"
                  element={
                    <ProtectedRoute>
                      <WhataNewsEdit />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </Router>
          </AuthProvider>
        </ModalProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
